import {useIntl} from "react-intl";
import classNames from "classnames/bind";
import closeIcon from "images/ic_close.svg";
import DropDownFoldIcon from "assets/image/Layout/PropertyPanel/ic_dropdown_fold.svg";
import DropDownUnfoldIcon from "assets/image/Layout/PropertyPanel/ic_dropdown_unfold.svg";
import styles from "./index.module.scss";
import {
  MODE_TYPE,
  SSAFY9_CODE,
  SSAFY9_ORGANIZATION,
  SSAFY10_CODE,
  SSAFY10_ORGANIZATION,
  SSAFY11_CODE,
  SSAFY11_ORGANIZATION,
  SEN_CODE,
  SEN_ORGANIZATIONS,
  ICE_CODE,
  IEN_ORGANIZATIONS,
  CLASS_CODE_LIST,
  enumCompetitionType,
} from "utils";
import SelectDropDown from "components/Common/Dropdown/SelectDropDown";
import {useState, useEffect} from "react";
import {isValidPhoneNumber, parsePhoneNumberFromString} from "libphonenumber-js";

// import {MODE} from "components/OOBCEditor/Component/Selector";

const cn = classNames.bind(styles);

function View({
  publishForm,
  progress,
  isClickUpload,
  dismiss,
  submitUpload,
  thumbPreview,
  isShowJoinToggle,
  onClickJoinToggle,
  selectedOrganization,
  onClickOrganization,
  onClickPublishMode,
  group,
  searchData,
  setSearchData,
  onClickContests,
  contest,
}) {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    setError, 
    formState: {errors},
  } = publishForm;

  const ORGANIZATIONS = {
    [SSAFY9_CODE]: SSAFY9_ORGANIZATION,
    [SSAFY10_CODE]: SSAFY10_ORGANIZATION,
    [SSAFY11_CODE]: SSAFY11_ORGANIZATION,
    [SEN_CODE]: SEN_ORGANIZATIONS,
    [ICE_CODE]: IEN_ORGANIZATIONS,
  };

  const HAS_TEAM_CLASS_CODE = [...CLASS_CODE_LIST, SSAFY9_CODE, SSAFY10_CODE, SSAFY11_CODE];
  const organization = group && ORGANIZATIONS[group] ? ORGANIZATIONS[group] : [];
  const name = watch("name");
  const description = watch("description");
  const phoneNumber = watch("phoneNumber");
  const intl = useIntl();

  // const [currentMode, setCurrentMode] = useState(MODE_TYPE.SINGLEPLAY_MODE);
  // const [isDropDownOpen, setIsDropDownOpen] = useState(false);
  // const handleModeChange = mode => {
  //   onClickPublishMode(mode);
  //   setCurrentMode(mode);
  //   setIsDropDownOpen(false);
  // };
  // const handleDropDown = () => {
  //   setIsDropDownOpen(prev => !prev);
  // };

  const [isContestDropDownOpen, setIsContestDropDownOpen] = useState(false);
  const handleContestDropDown = () => {
    setIsContestDropDownOpen(prev => !prev);
  };
  const handleContestChange = e => {
    onClickContests(e);
    setIsContestDropDownOpen();
  };

  const [isOrganizationDropDownOpen, setIsOrganizationDropDownOpen] = useState(false);
  const handleOrganizationDropDown = () => {
    setIsOrganizationDropDownOpen(prev => !prev);
  };
  const handleOrganizationChange = title => {
    onClickOrganization(title);
    setIsOrganizationDropDownOpen();
  };

  function validateKoreanPhoneNumber(input) {
    const cleanedInput = input.replace(/[^0-9]/g, '');
    if (cleanedInput.length < 10 || cleanedInput.length > 11) {
      return {
        isValid: false,
        error: 'Phone number must be between 9 and 11 digits long.',
      };
    }
    const phoneNumber = parsePhoneNumberFromString(cleanedInput, 'KR');
    if (!phoneNumber || !phoneNumber.isValid()) {
      return {
        isValid: false,
        error: 'Invalid Korean phone number format.',
      };
    }
    const validPrefixes = [
      '010', '10', '011', '11', '016', '16', '017', '17', '018', '18', '019', '19', 
      '02', 
      '031', '31', '032', '32', '033', '33', '034', '34', 
      '041', '41', '042', '42', '043', '43', '044', '44', '051', '51', '052', '52',
      '053', '53', '054', '54', '055', '55', '061', '61', '062', '62', '063', '63', '064', '64'
    ];
    const startsWithValidPrefix = validPrefixes.some(prefix => cleanedInput.startsWith(prefix));
    if (!startsWithValidPrefix) {
      return {
        isValid: false,
        error: 'Phone number must start with a valid prefix.',
      };
    }
    return {
      isValid: true,
      formattedNumber: phoneNumber.formatNational(),
    };
  }

  const phoneNumberInputField = document.getElementById("phoneNumber") || {};
  const handleBlur = (e) => {
    const currentInputValue = phoneNumberInputField?.value;
    const id = "phoneNumber";
    const validatedNumber = validateKoreanPhoneNumber(currentInputValue);
    if (!validatedNumber.isValid) {
      phoneNumberInputField.value = '';
      setValue(id, '');
      setError(id, {type: "required", message: validatedNumber.error});
    } else {
      phoneNumberInputField.value = validatedNumber.formattedNumber;
      setValue(id, currentInputValue);
      publishForm.clearErrors(id);
    }
  }

  const [consentGiven, setConsentGiven] = useState(false);
  const [consentInfoOpened, setConsentInfoOpened] = useState(false);
  const handleChange = (e) => {
    setConsentGiven(e.target.checked);
  }

  const [canBePublished, setCanBePublished] = useState(false);
  const [nameInputValue, descriptionInputValue, phoneNumberInputValue] = ["name", "description", "phoneNumber"].map(id => document.getElementById(id) || {}).map(elem => elem?.value);
  useEffect(() => {
    if (nameInputValue && descriptionInputValue && ((contest === "None") || (contest !== "None" && phoneNumberInputValue && consentGiven))) {
      setCanBePublished(true);
    } else {
      setCanBePublished(false);
    }
  }, [nameInputValue, descriptionInputValue, phoneNumberInputValue, contest, consentGiven]);

  return (
    <form className={cn("popup")} onSubmit={handleSubmit(submitUpload)}>
      <header className={cn("header")}>
        Publish to Redbrick
        <img onClick={dismiss} src={closeIcon} alt="close popup" />
      </header>
      {!isClickUpload ? (
        <div className={cn("content")}>
          <div className={cn("line")}>
            <div className={cn("titleline")}>
              <p className={cn("title", "redstar")}>Name</p>
              <span>{name?.length}/50</span>{" "}
            </div>
            <div className={cn("wrap")}>
              <input
                id="name"
                type="text"
                maxLength={50}
                autoComplete="off"
                autoCorrect="off"
                className={cn("name", errors?.name && "error")}
                {...register("name")}
                placeholder={intl.formatMessage({
                  id: "ID_PUBLISH_POPUP_TITLE_PLACEHOLDER",
                })}
                required
              />
            </div>
          </div>
          <div className={cn("line")}>
            <div className={cn("titleline")}>
              <p className={cn("title", "redstar")}>Description</p> <span>{description?.length}/1000</span>
            </div>
            <div className={cn("wrap")}>
              <textarea
                id="description"
                maxLength={1000}
                autoComplete="off"
                spellCheck="false"
                autoCorrect="off"
                className={cn("textarea", errors?.description && "error")}
                {...register("description")}
                placeholder={intl.formatMessage({
                  id: "ID_PUBLISH_POPUP_DESCRIPTION_PLACEHOLDER",
                })}
                required
              />
            </div>
          </div>

          {/* TODO 싱글 또는 멀티모드로 플레이 모드를 설정합니다. */}

          <div className={cn("line")}>
            <p className={cn("title")}>Thumbnail</p>
            <div className={cn("filebox")}>
              <label htmlFor="thumbnail" className={cn("thumbnail_label")}>
                {thumbPreview && <img src={thumbPreview} alt="thumbnail" />}
              </label>
              {errors?.thumbnail && <p className={cn("thumb_error")}>{errors.thumbnail.message}</p>}
              <input
                type="file"
                id="thumbnail"
                accept=".jpg,.jpeg,.png"
                {...register("thumbnail", {
                  validate: {
                    lessThan3MB: files => files[0]?.size < 3 * 3 * 1000 * 1000 || "최대 3MB",
                  },
                })}
              />
            </div>
          </div>


          <PublishDropDown
            name={"Challenge/Contest"}
            value={contest}
            titles={Object.keys(enumCompetitionType)}
            func={handleContestChange}
            handleDropDown={handleContestDropDown}
            isDropDownOpen={isContestDropDownOpen}
          />
          {contest !== "None" && group && HAS_TEAM_CLASS_CODE.includes(group) && (    
            <PublishDropDown
              name={"Team"}
              value={isShowJoinToggle ? searchData : selectedOrganization}
              titles={organization.filter(data => (data !== "전체") && (searchData ? data.includes(searchData) : data))}
              func={handleOrganizationChange}
              handleDropDown={handleOrganizationDropDown}
              isDropDownOpen={isOrganizationDropDownOpen}
              required={true}
            />
          )}
          {contest !== "None" && group && HAS_TEAM_CLASS_CODE.includes(group) && (
            <div className={cn("line")}>
              <div className={cn("titleline")}>
                <p className={cn("title", "redstar")}>Phone Number</p>
                <span>{phoneNumber?.length}/50</span>{" "}
              </div>
              <div className={cn("wrap")}>
                <input
                  id="phoneNumber"
                  type="text"
                  maxLength={50}
                  autoComplete="off"
                  spellCheck="false"
                  autoCorrect="off"
                  className={cn("phoneNumber", errors?.phoneNumber && "error")}
                  {...register("phoneNumber", {
                    required: contest !== "None",
                    validate: (value) => isValidPhoneNumber(value, "KR") || "Invalid number format",
                  })}
                  onBlur={handleBlur}
                  placeholder={intl.formatMessage({
                    id: "ID_PUBLISH_POPUP_PHONENUMBER_PLACEHOLDER",
                  })}
                />
              </div>
            </div>
          )}
          {contest !== "None" && group && HAS_TEAM_CLASS_CODE.includes(group) && (
            <div className={cn("user_consent_box")}>
              <div className={cn("header")}>
                <input id="consent" type="checkbox" className={cn("checkbox")} onChange={handleChange}></input>
                <div className={cn("title")}>{intl.formatMessage({id: "ID_PUBLISH_POPUP_USER_CONSENT"})}</div>
                <img className={cn("dropdown_icon")} alt="dropdown icon" src={consentInfoOpened ? DropDownUnfoldIcon : DropDownFoldIcon} onClick={() => setConsentInfoOpened(state => !state)}/>
              </div>
              {consentInfoOpened && (
                <div className={cn("detailed_info")}>
                  {intl.formatMessage({id: "ID_PUBLISH_POPUP_USER_CONSENT_DETAILED_INFO"}).split('|').map((line, index) => <p key={index} className={cn("line")}>{"✓   " + line.trim()}</p>)}
                </div>
              )}
            </div>
          )}

          <div className={cn("buttons")}>
            <button type="button" onClick={dismiss} className={cn("button")}>
              Cancel
            </button>
            <button className={cn("button", "upload")} disabled={!canBePublished}>Publish</button>
          </div>
        </div>
      ) : progress < 100 ? (
        <div className={cn("uploading")}>
          <div className={cn("uploading_box")}>
            <p>Uploading 3D world ...</p>
            <div className={cn("progress_box")}>
              <div className={cn("progress_value")}>
                <p>{progress}%</p>
              </div>
              <div className={cn("uploading_progress")}>
                <div style={{width: `${progress}%`}} />
              </div>
            </div>
          </div>
          <button type="button" className={cn("button")} onClick={dismiss}>
            Cancel
          </button>
        </div>
      ) : (
        <div className={cn("uploading")}>
          <div className={cn("uploading_box")}>
            <p>Publishing completed.</p>
          </div>
          <button type="button" className={cn("button")} onClick={dismiss}>
            Confirm
          </button>
        </div>
      )}
    </form>
  );
}

export default View;

const PublishDropDown = ({name, value, titles, func, close, handleDropDown, isDropDownOpen, required = false}) => {
  // 이렇게 한다음에 타이틀을 SelectDropDown에 map돌리자
  // name이 항목 이름
  // value가 선택된 값(드랍다운 인풋에 표시될 값)

  return (
    <div className={cn("line", "line_team")}>
      <p className={required ? cn("title", "redstar") : cn("title")}>{name}</p>
      <div className={cn("wrap")}>
        <div className={cn("playmode")}>
          <div onClick={handleDropDown}>
            <div>
              <p className={cn("mode_text")}>{value}</p>
              <img className={cn("rotate")} alt="dropdown icon" src={isDropDownOpen ? DropDownUnfoldIcon : DropDownFoldIcon} />
            </div>
          </div>
          {isDropDownOpen && (
            <SelectDropDown style={{position: "absolute", width: "304px", top: "10px", borderRadius: "5px"}}>
              {titles.map(title => (
                <div className={cn("drop_input")} title={title} onClick={() => func(title)} key={title}>
                  <p className={cn("row")} style={{overflowX: "auto", overflowY: "hidden", fontSize: "12px", marginRight: "12px"}}>{title}</p>
                </div>
              ))}
            </SelectDropDown>
          )}
        </div>
      </div>
    </div>
  );
};